import axios from "axios";
import Config from "../../config/index";
import RefreshTokenHandler from "./refresh-token";
import { InvestmentTransactionFields } from "../../hooks/useVpsTransaction";

/**
 * @param email
 */
const getNatureOfTx = async (email: string) => {
  const url = `${Config.baseUrl}/mastertxn/not?email=${email}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getNatureOfTx(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
/**
 * @param email
 */
const getModeOfTx = async (email: string) => {
  const url = `${Config.baseUrl}/mastertxn/tot?email=${email}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getModeOfTx(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
/**
 * @param email
 */
const getModeOfPayments = async (email: string) => {
  const url = `${Config.baseUrl}/mastertxn/mop?email=${email}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getModeOfPayments(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 * @param email
 */
const getTxnCatagory = async (email: string) => {
  const url = `${Config.baseUrl}/mastertxn/txn-catagory?email=${email}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getTxnCatagory(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 */
const getAllPendingTransactions = async (
  email: string,
  status: string,
  search_value: string,
  created_by: string = "",
  page_number: string = "",
  txnr_type: string = "",
  fund_code: string = "",
  amc_code: string = "",
  hasChild: string = "",
  page_path?: string,
) => {
  const url = `${Config.baseUrl}/transaction?email=${email}&status=${status}&search_value=${search_value}&created-by=${created_by}&page_number=${page_number}&page_size=20&txnr_type=${txnr_type}&fund_code=${fund_code}&amc_code=${amc_code}&page_path=${page_path}`;

  const params: any = { is_sub_transaction: "false" };

  if (hasChild) {
    params.associated_transaction = hasChild;
    params.is_sub_transaction = "true";
    params.no_child_check = "true";
  }
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
      params,
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllPendingTransactions(
          email,
          status,
          search_value,
          (created_by = ""),
          (page_number = ""),
          txnr_type,
          fund_code,
          amc_code,
          "",
          page_path,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const updateTransactionStatus = async (
  email: string,
  status: string,
  trx_id: string,
  note: string,
  check_list: any,
) => {
  const url = `${Config.baseUrl}/transaction/update-status`;
  try {
    const result: any = await axios.put(
      url,
      {
        email,
        status,
        trx_id,
        note,
        check_list,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateTransactionStatus(
          email,
          status,
          trx_id,
          note,
          check_list,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

// add Equity
const addEquityTransaction = async (
  email: string,
  fund: string,
  account_no: string,
  name_of_beneficiary: string,
  beneficiary_bank: string,
  beneficiary_branch: string,
  beneficiary_account: string,
  instrument_date: string,
  symbol: string,
  instrument_no: string,
  instrument_type: string,
  type_of_transaction: string,
  trade_type: string,
  brokage: string,
  gross_amount: string,
  fed: string,
  trade_date: string,
  sst: string,
  commission: string,
  settlement_date: string,
  net_amount: string,
  broker_code: string,
  // broker_name: string,
  volume: string,
  avg_rate: string,
  amc_name: string,
  trx_id: string,
  broker_name: string,
  txn_status?: string,
  note?: string,
  check_list?: any,
  updated_by_role?: string,
) => {
  let type_of_security = symbol;
  const url = `${Config.baseUrl}/transaction/equity-settlement/`;
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        fund,
        account_no,
        name_of_beneficiary,
        beneficiary_bank,
        beneficiary_branch,
        beneficiary_account,
        instrument_date,
        symbol,
        type_of_security,
        instrument_no,
        instrument_type,
        type_of_transaction,
        trade_type,
        brokage,
        gross_amount,
        fed,
        trade_date,
        sst,
        commission,
        settlement_date,
        net_amount,
        broker_code,
        volume,
        avg_rate,
        amc_name,
        trx_id,
        broker_name,
        txn_status,
        note,
        check_list,
        updated_by_role,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addEquityTransaction(
          email,
          fund,
          account_no,
          name_of_beneficiary,
          beneficiary_bank,
          beneficiary_branch,
          beneficiary_account,
          instrument_date,
          symbol,
          instrument_no,
          instrument_type,
          type_of_transaction,
          trade_type,
          brokage,
          gross_amount,
          fed,
          trade_date,
          sst,
          commission,
          settlement_date,
          net_amount,
          broker_code,
          volume,
          avg_rate,
          amc_name,
          trx_id,
          broker_name,
          txn_status,
          note,
          check_list,
          updated_by_role,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

//display type
const getCaptype = async () => {
  const url = `${Config.baseUrl}/transaction/txntypes`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCaptype();
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getCoListing = async (email: string, amcCode: string) => {
  const url = `${Config.baseUrl}/amc/members-by-code?email=${email}&amc_code=${amcCode}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCoListing(email, amcCode);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getAllTransactions = async (
  email: string,
  status: string,
  search_value: string,
  created_by: string = "",
  page_number: string = "",
  create_email: string = "",
) => {
  const url = `${Config.baseUrl}/transaction?email=${email}&status=${status}&search_value=${search_value}&created-by=${created_by}&page_number=${page_number}&page_size=10&create_email=${create_email}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllTransactions(
          email,
          status,
          search_value,
          (created_by = ""),
          (page_number = ""),
          (create_email = ""),
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 */
const getAllAmcTransactions = async (
  email: string,
  amc_name,
  status: string,
  search_value: string,
  created_by: string = "",
  page_number: string = "",
) => {
  const url = `${Config.baseUrl}/transaction/amc-txns?email=${email}&status=${status}&search_value=${search_value}&created-by=${created_by}&page_number=${page_number}&page_size=10&amc_code=${amc_name}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllAmcTransactions(
          email,
          amc_name,
          status,
          search_value,
          (created_by = ""),
          (page_number = ""),
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const updateBulkTransactionStatus = async (
  email: string,
  role: string,
  status: string,
  note: string,
  check_list: any,
  data: any,
) => {
  const url = `${Config.baseUrl}/transaction/bulk-update`;
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        role,
        status,
        note,
        check_list,
        data,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateBulkTransactionStatus(
          email,
          role,
          status,
          note,
          check_list,
          data,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getLedger = async (email: string, txn_id: string) => {
  const url = `${Config.baseUrl}/transaction/get-ledger-by-txnid?email=${email}&txn_id=${txn_id}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getLedger(email, txn_id);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const searchTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  status: string,
  search_value: string,
  page_number: string,
  txnr_type: string = "",
  page_path?: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-txn-filter?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&txn_status=${status}&txn_id=${search_value}&page_number=${page_number}&page_size=20&txnr_type=${txnr_type}&page_path=${page_path}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await searchTransactions(
          email,
          amc_code,
          fund_code,
          status,
          search_value,
          page_number,
          txnr_type,
          page_path,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getCorporateAnnouncemetTxns = async (
  email: string,
  amc_code: string,
  page_number: string = "",
  fund_code: string = "",
) => {
  // const url = `${Config.baseUrl}/get-corporate-announcements?email=${email}&status=${status}&search_value=${search_value}&created-by=${created_by}&page_number=${page_number}&page_size=10`;
  const url = `${Config.baseUrl}/transaction/get-corporate-announcements?email=${email}&amc_code=${amc_code}&page_number=${page_number}&page_size=10&fund_code=${fund_code}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCorporateAnnouncemetTxns(
          email,
          amc_code,
          page_number,
          fund_code,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

export function isAbortError(
  err: unknown,
): err is { name?: string; code?: string; message?: string } {
  if (!err) return false;

  // DOMException from fetch usually has .name === 'AbortError'
  // Some libs throw an Error with message 'Aborted' or similar.
  try {
    const e = err as any;
    if (e && typeof e === "object") {
      if (e.name === "AbortError") return true; // DOMException
      if (e.code === "ERR_CANCELED") return true; // axios cancellation (v1+)
      if (typeof e.message === "string" && /abort(ed)?/i.test(e.message))
        return true; // fallback
      if ((e as Error).stack && /Abort/i.test(String(e.name || "")))
        return true;
    }
  } catch {
    // ignore
  }
  return false;
}

const getPreviousTransactionsCGTCalculation = async (
  email: string,
  amc_code: string,
  fund_code: string,
  folio_number: string,
  redemption_date: string,
  signal?: AbortSignal | undefined,
) => {
  const url = `${Config.baseUrl}/transaction/get-completed-txn-filter?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&folio_number=${folio_number}&redemption_date=${redemption_date}`;

  let cancelSource = axios.CancelToken.source();

  const onAbort = () => cancelSource.cancel("aborted by AbortController");

  try {
    let result: any = null;

    if (signal) {
      signal.addEventListener("abort", onAbort);

      result = await axios.get(url, {
        cancelToken: cancelSource.token,
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      });
    } else {
      result = await axios.get(url, {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      });
    }

    if (signal?.aborted) throw new DOMException("Aborted", "AbortError");

    return result;
  } catch (err: any) {
    if (isAbortError(err)) {
      throw err;
    } else {
      if (err.response.data.status == 401) {
        let responseToHandle = err.response.data;
        let result = await RefreshTokenHandler.handleIt(responseToHandle);
        if (result.status) {
          return await getPreviousTransactionsCGTCalculation(
            email,
            amc_code,
            fund_code,
            folio_number,
            redemption_date,
            signal,
          );
        } else {
          throw err;
          // return result
        }
      } else {
        throw err;
      }
    }
  } finally {
    if (signal) {
      signal?.removeEventListener("abort", onAbort);
    }
  }
};

const getLiveCgtCalculation = async (
  email: string,
  amc_code: string,
  fund_code: string,
  fund_units: string,
  folio_number: string,
  redemption_date: string,
  signal?: AbortSignal | undefined,
) => {
  const url = `${Config.baseUrl}/investor-app/transactions/cgt/calculate?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&fund_units=${fund_units}&folio_number=${folio_number}&redemption_date=${redemption_date}`;

  let cancelSource = axios.CancelToken.source();

  const onAbort = () => cancelSource.cancel("aborted by AbortController");

  try {
    let result: any = null;

    if (signal) {
      signal.addEventListener("abort", onAbort);

      result = await axios.get(url, {
        cancelToken: cancelSource.token,
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      });
    } else {
      result = await axios.get(url, {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      });
    }

    if (signal?.aborted) throw new DOMException("Aborted", "AbortError");

    return result;
  } catch (err: any) {
    if (isAbortError(err)) {
      throw err;
    } else {
      if (err.response.data.status == 401) {
        let responseToHandle = err.response.data;
        let result = await RefreshTokenHandler.handleIt(responseToHandle);
        if (result.status) {
          return await getPreviousTransactionsCGTCalculation(
            email,
            amc_code,
            fund_code,
            folio_number,
            redemption_date,
            signal,
          );
        } else {
          throw err;
          // return result
        }
      } else {
        throw err;
      }
    }
  } finally {
    if (signal) {
      signal?.removeEventListener("abort", onAbort);
    }
  }
};

const headerTxnSearchFunctionality = async (
  email: string,
  amc_code: string,
  txn_id: string,
  fund_code?: string,
) => {
  const url = `${Config.baseUrl}/transaction/search-txn-header?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&txn_id=${txn_id}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await headerTxnSearchFunctionality(
          email,
          amc_code,
          txn_id,
          fund_code,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getFundExpensesByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-expense-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFundExpensesByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getBankProfitAccrualByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-bank-profit-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getBankProfitAccrualByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getPostNavAccrualByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-post-nav-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getPostNavAccrualByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getTrusteeFeeAccrualByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-trustee-fee-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getTrusteeFeeAccrualByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getManagementFeeAccrualByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-management-fee-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getManagementFeeAccrualByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getSecpFeeAccrualByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-secp-fee-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getSecpFeeAccrualByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getAccountOperationFeeAccrualByTransactions = async (
  email: string,
  amc_code: string,
  fund_code: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/transaction/get-account-operation-fee-accrual-txns-by-date-range?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&from_date=${from_date}&to_date=${to_date}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAccountOperationFeeAccrualByTransactions(
          email,
          amc_code,
          fund_code,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getInvestmentTransactionById = async (id) => {
  const url = `${Config.baseUrl}/transaction/${id}`;
  try {
    const result: any = await axios.get(url, {
      params: { source_portal: "MACS-KJ" },
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (
      err.response.data.status == 401 ||
      err.response.status == 403 ||
      err.response.statusCode == 403
    ) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getInvestmentTransactionById(id);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const addInvestmentTransaction = async (
  email: string,
  fields: InvestmentTransactionFields,
  role?: string,
  source_portal?: string,
) => {
  const url = `${Config.baseUrl}/transaction/vps-transactions`;

  try {
    // Clean systematic_investment data - remove accounts from sub-funds
    let cleanedSystematicInvestment = null;
    let units = 0;

    if (fields.systematic_investment) {
      cleanedSystematicInvestment = {
        ...fields.systematic_investment,
        investment_blocks: fields.systematic_investment.investment_blocks.map(
          (block) => ({
            ...block,
            subFunds: block.subFunds.map((subFund) => {
              // Remove accounts array but keep selected_account data
              const { accounts, ...cleanSubFund } = subFund;
              units += parseFloat(cleanSubFund.units);
              return cleanSubFund;
            }),
          }),
        ),
      };
    }

    // Extract fund_code from systematic_investment if available
    const fundCode =
      fields.systematic_investment?.investment_blocks?.[0]?.selectedParentFund
        ?.value ||
      fields.fund_code ||
      "";

    const result: any = await axios.post(
      url,
      {
        email,
        ...fields,
        fund_code: fundCode, // Set from parent fund
        role: role || "",
        source_portal: "MACS",
        account_no: fields.account_number,
        fund_account: fields.account_title,
        gross_amount:
          fields.txnr_type === "changeofallocation"
            ? fields.gross_amount
            : fields.systematic_investment?.investment_amount || 0,
        net_amount:
          fields.txnr_type === "changeofallocation"
            ? fields.net_amount
            : fields.systematic_investment?.investment_amount || 0,
        executed_date: fields.settlement_date,
        execution_date: fields.settlement_date,
        systematic_investment: cleanedSystematicInvestment, // Send cleaned data
        units,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (
      err.response?.data?.status == 401 ||
      err.response?.status == 403 ||
      err.response?.statusCode == 403
    ) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addInvestmentTransaction(
          email,
          fields,
          role,
          source_portal,
        );
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

const updateVPSTxn = async (data: any) => {
  const url = `${Config.baseUrl}/transaction/update-vps-txn`;
  try {
    const result: any = await axios.post(url, data, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (
      err.response.data.status == 401 ||
      err.response.status == 403 ||
      err.response.statusCode == 403
    ) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateVPSTxn(data);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const reverseTransactionService = async (data: any) => {
  const url = `${Config.baseUrl}/transaction/reverse-status`;

  try {
    const result = await axios.patch(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result.data; // axios returns data inside .data
  } catch (err: any) {
    if (err.response?.status === 401 || err.response?.status === 403) {
      const responseToHandle = err.response.data;
      const result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await reverseTransactionService(data);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export {
  getAllAmcTransactions,
  getCoListing,
  getAllTransactions,
  getTxnCatagory,
  getCaptype,
  updateTransactionStatus,
  getNatureOfTx,
  addEquityTransaction,
  getModeOfTx,
  getModeOfPayments,
  getAllPendingTransactions,
  updateBulkTransactionStatus,
  getLedger,
  searchTransactions,
  getCorporateAnnouncemetTxns,
  getPreviousTransactionsCGTCalculation,
  headerTxnSearchFunctionality,
  getFundExpensesByTransactions,
  getBankProfitAccrualByTransactions,
  getPostNavAccrualByTransactions,
  getTrusteeFeeAccrualByTransactions,
  getManagementFeeAccrualByTransactions,
  getSecpFeeAccrualByTransactions,
  getAccountOperationFeeAccrualByTransactions,
  getInvestmentTransactionById,
  getLiveCgtCalculation,
  updateVPSTxn,
  addInvestmentTransaction,
  reverseTransactionService,
};
